import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { CardViewStyles } from './CardViewStyles';

const linkStyle: React.CSSProperties = {
  color: CommonStyles.Colors.HyperlinkBlue,
  fontFamily: CommonStyles.Fonts.HeavyFont,
  position: 'relative',
  zIndex: 1 // to ensure it appears above the card's <a> tag
};

const inactiveLinkStyle: React.CSSProperties = {
  color: TabStyles.Typography.Color.PrimaryMedium,
  fontFamily: CommonStyles.Fonts.HeavyFont,
};

export interface CardTextAndLinkProps {
  text: string;
  url: string;
  urlDisplayName: string;
  marginLeft?: number;
}

export class CardTextAndLink extends React.PureComponent<CardTextAndLinkProps> {

  public render(): JSX.Element {
    const styleOverrides: React.CSSProperties = {};
    if (this.props.marginLeft) {
      styleOverrides.marginLeft = this.props.marginLeft;
      styleOverrides.maxWidth = CardViewStyles.CardTextAndLinkMaxWidth - this.props.marginLeft;
    }

    return (
      <div style={styleOverrides} className={CardViewStyles.CardTextAndLink} title={this.props.text + ' ' + this.props.urlDisplayName}>
        {this.props.text + ' '}
        {this.props.url &&
          <a style={linkStyle} href={this.props.url} onClick={this.onLinkClick}>
            {this.props.urlDisplayName}
          </a>
        }
        {!this.props.url &&
          <span style={inactiveLinkStyle}>{this.props.urlDisplayName}</span>
        }
      </div>
    );
  }

  private onLinkClick = (e: React.MouseEvent<HTMLAnchorElement>): boolean => {
    e.stopPropagation();
    return false;
  }
}
